module.exports = __webpack_public_path__ + "img/121.9758cc01.png";